import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";

var requestSchema = yup.object({
  appointmentId: yup.number().required(),
  note: yup.string().required(),
});

export function useAddAppointmentNoteMutation(options = {}) {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });
      return await http.post(HTTP_ENDPOINTS.appointments.addNote(), {
        appointment_id: req.appointmentId,
        note: req.note,
      });
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.appointments.appointment],
        });
        options.onSuccess?.(...args);
      },
    },
  );
}
